import { Action, createReducer, on } from "@ngrx/store";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import { ServiceModeDTO } from "src/app/models/service-modes/service-modesDTO";

import * as ServiceModeActionTypes from "../../actions/services-modes/services-mode.actions";

export interface ServiceModeState {
  isLoading: boolean;
  serviceModes: ServiceModeDTO[];
  serviceExcelModes: ServiceModeDTO[];
  serviceMode: ServiceModeDTO;
  totalRecords: number;
  created: boolean;
  serviceModeTableConfig: ColumnSorterInfo[];
}

export const initialState: ServiceModeState = {
  created: false,
  isLoading: false,
  serviceExcelModes: null,
  serviceMode: null,
  serviceModeTableConfig: null,
  serviceModes: null,
  totalRecords: 0,
};

const serviceModeReducer = createReducer(
  initialState,
  on(ServiceModeActionTypes.resetServiceModeState, () => initialState),
  on(ServiceModeActionTypes.getServiceModes, (state, { options }) => {
    return {
      ...state,
      options: options,
      isLoading: true,
    };
  }),
  on(ServiceModeActionTypes.loadServiceModes, (state, { response }) => {
    return {
      ...state,
      serviceModes: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
      totalRecords: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(ServiceModeActionTypes.getServiceModesExcel, (state, { options }) => {
    return {
      ...state,
      options: options,
      isLoading: true,
    };
  }),
  on(ServiceModeActionTypes.loadServiceModesExcel, (state, { response }) => {
    return {
      ...state,
      serviceExcelModes: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
    };
  }),
  on(ServiceModeActionTypes.getServiceModeTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(
    ServiceModeActionTypes.loadServiceModeTableConfig,
    (state, { response }) => {
      return {
        ...state,
        serviceModeTableConfig:
          (response as any)?.result?.value?.tableColumnInfo ?? undefined,
      };
    }
  ),
  on(ServiceModeActionTypes.saveServiceModeTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(ServiceModeActionTypes.getServiceMode, (state) => {
    return {
      ...state,
      isLoading: true,
      created: false,
    };
  }),
  on(ServiceModeActionTypes.loadServiceMode, (state, { serviceMode }) => ({
    ...state,
    serviceMode: (serviceMode as any).result,
    isLoading: false,
    error: null,
  })),
  on(ServiceModeActionTypes.resetServiceMode, (state) => {
    return {
      ...state,
      serviceMode: null,
      error: null,
    };
  }),
  on(ServiceModeActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(ServiceModeActionTypes.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(
    ServiceModeActionTypes.createServiceMode,
    ServiceModeActionTypes.updateServiceMode,
    (state) => {
      return {
        ...state,
        isLoading: true,
      };
    }
  )
);

export function reducer(state: ServiceModeState | undefined, action: Action) {
  return serviceModeReducer(state, action);
}
